export default __webpack_public_path__ + "static/media/regulatory--no-rickshaws--g2.61c13947.png";